namespace $.$$ {
	export class $hyoo_budget_intro extends $.$hyoo_budget_intro {
		
		@ $mol_mem
		readme() {
			return this.$.$mol_fetch.text( 'hyoo/budget/readme.md' )
		}
		
	}
}
